<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center" fxFlex.gt-sm="100">

    <div class="mr-20">
        <mat-form-field class="full-width-multi-select" floatLabel="always">
            <mat-label>Autor</mat-label>
            <mat-select (selectionChange)="OnAuthorChange($event)" [(ngModel)]="defaultValue">
                <mat-option *ngFor="let option of authorList | listFilter: 'VISIBLE': true" [value]="option.value">
                    {{option.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="mr-20" *ngIf="dropDownActivate.user">
        <mat-form-field  class="full-width-multi-select" floatLabel="always">
            <mat-label>Usuario</mat-label>
            <mat-select (selectionChange)="OnValueChange($event, 'user')">
                <mat-option *ngFor="let option of userList" [value]="option.value" >
                    {{option.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="mr-20" *ngIf="dropDownActivate.doctor">
        <mat-form-field  class="full-width-multi-select" floatLabel="always">
            <mat-label>Medico</mat-label>
            <mat-select (selectionChange)="OnValueChange($event, 'doctor')">
                <mat-option *ngFor="let option of medicoList" [value]="option.value">
                    {{option.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    
    </div>
    <div class="mr-20" *ngIf="dropDownActivate.coordinador">
        <mat-form-field  class="full-width-multi-select" floatLabel="always">
            <mat-label>Coordinador</mat-label>
            <mat-select (selectionChange)="OnValueChange($event, 'coordinator')">
                <mat-option *ngFor="let option of coordinatorList" [value]="option.value">
                    {{option.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

</div>